/**
 * Fires a custom event when an element with [data-buy] comes into view.
 * The event detail contains the element and its data-buy value.
 * @param {string} selector - CSS selector to track (default: '[data-buy]')
 * @param {number} threshold - IntersectionObserver threshold (default: 0.5)
 * @param {Element} container - Container to observe (default: document.body)
 */
/* eslint-disable-next-line max-lines-per-function */
export function eventOnElementInView(selector = '[data-buy]', attribute = 'data-buy', eventname = 'elementInView', threshold = 0.5, container = document.body) {
    const trackedProducts = new Set();
    const observerOptions = { root: null, rootMargin: '0px', threshold };

    const intersectionObserver = new IntersectionObserver(handleIntersect, observerOptions);

    function handleIntersect(entries) {
        entries.forEach(entry => {
            if (
                entry &&
                typeof entry === 'object' &&
                'isIntersecting' in entry &&
                entry.isIntersecting
            ) {
                fireEvent(entry.target);
            }
        });
    }

    function fireEvent(el) {
        const attributeValue = el.getAttribute(attribute);
        if (!trackedProducts.has(attributeValue)) {
            trackedProducts.add(attributeValue);
            window.dispatchEvent(new CustomEvent(eventname, {
                detail: { element: el, attribute, value: attributeValue }
            }));
        }
    }

    function observeAll() {
        container.querySelectorAll(selector).forEach(el => intersectionObserver.observe(el));
    }
    observeAll();

    const mutationObserver = new MutationObserver(observeAll);
    mutationObserver.observe(container, { childList: true, subtree: true });
}